import { Box, styled } from '@mui/material';

export const LoaderWrapper = styled(Box)({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'center',
});
